function initFaqForm(section) {
  const dropdown = section.querySelector('.faq-form__dropdown');
  if (!dropdown) return;

  const trigger = dropdown.querySelector('.faq-form__dropdown-trigger');
  const list = dropdown.querySelector('.faq-form__dropdown-list');
  const valueEl = dropdown.querySelector('.faq-form__dropdown-value');
  const options = dropdown.querySelectorAll('.faq-form__dropdown-option');
  const panels = section.querySelectorAll('.faq-form__panel');

  // Track observers for cleanup
  const observers = [];

  function toggleDropdown() {
    const isOpen = dropdown.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', isOpen);
  }

  function closeDropdown() {
    dropdown.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function selectOption(option) {
    options.forEach(function(o) { o.classList.remove('is-selected'); o.setAttribute('aria-selected', 'false'); });
    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');
    valueEl.textContent = option.textContent;
    dropdown.classList.add('has-value');
    closeDropdown();

    const selected = option.getAttribute('data-value');
    panels.forEach(function(panel) {
      panel.style.display = panel.getAttribute('data-form-index') === selected ? '' : 'none';
    });
  }

  trigger.addEventListener('click', toggleDropdown);

  options.forEach(function(option) {
    option.addEventListener('click', function() { selectOption(option); });
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) closeDropdown();
  });

  // Keyboard navigation
  trigger.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!dropdown.classList.contains('is-open')) toggleDropdown();
      const first = list.querySelector('.faq-form__dropdown-option');
      if (first) first.focus();
    }
  });

  list.addEventListener('keydown', function(e) {
    const focused = document.activeElement;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = focused.nextElementSibling;
      if (next) next.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = focused.previousElementSibling;
      if (prev) prev.focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (focused.classList.contains('faq-form__dropdown-option')) selectOption(focused);
    } else if (e.key === 'Escape') {
      closeDropdown();
      trigger.focus();
    }
  });

  // Privacy policy link
  const privacyUrl = section.getAttribute('data-privacy-url');
  const privacyText = section.getAttribute('data-privacy-text');

  const privacyRegex = privacyText ? new RegExp('(' + privacyText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i') : null;

  function linkifyPrivacy(shadowRoot) {
    if (!privacyUrl || !privacyRegex) return;
    shadowRoot.querySelectorAll('label, fieldset').forEach(function(el) {
      if (el.querySelector('.faq-privacy-link')) return;
      if (!privacyRegex.test(el.textContent)) return;
      linkifyTextNode(el);
    });
  }

  function linkifyTextNode(el) {
    Array.from(el.childNodes).forEach(function(node) {
      if (node.nodeType === 3 && privacyRegex.test(node.textContent)) {
        const parts = node.textContent.split(privacyRegex);
        const frag = document.createDocumentFragment();
        parts.forEach(function(part) {
          if (privacyRegex.test(part)) {
            const a = document.createElement('a');
            a.href = privacyUrl;
            a.target = '_blank';
            a.className = 'faq-privacy-link';
            a.textContent = part;
            frag.appendChild(a);
          } else if (part) {
            frag.appendChild(document.createTextNode(part));
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && !node.classList.contains('faq-privacy-link')) {
        linkifyTextNode(node);
      }
    });
  }

  // Inject custom stylesheet into Shopify Forms shadow DOM
  const stylesheetUrl = section.getAttribute('data-override-stylesheet');

  function injectStyles(shadowRoot) {
    if (!stylesheetUrl || shadowRoot.querySelector('[data-faq-override]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheetUrl;
    link.setAttribute('data-faq-override', '');
    shadowRoot.prepend(link);
  }

  function fixLabels(shadowRoot) {
    shadowRoot.querySelectorAll('label[id^="label-"]').forEach(function(label) {
      if (label.style.top) {
        label.style.removeProperty('top');
      }
    });
  }

  function wrapStarsInNode(el) {
    Array.from(el.childNodes).forEach(function(node) {
      if (node.nodeType === 3 && node.textContent.indexOf('*') !== -1) {
        const parts = node.textContent.split('*');
        const frag = document.createDocumentFragment();
        parts.forEach(function(part, i) {
          if (part) frag.appendChild(document.createTextNode(part));
          if (i < parts.length - 1) {
            const span = document.createElement('span');
            span.className = 'faq-star';
            span.textContent = '*';
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && !node.classList.contains('faq-star')) {
        wrapStarsInNode(node);
      }
    });
  }

  function colorStars(shadowRoot) {
    shadowRoot.querySelectorAll('label, [data-testid="date-birthday"] > div:first-child').forEach(function(label) {
      if (label.querySelector('.faq-star')) return;
      if (label.textContent.indexOf('*') === -1) return;
      wrapStarsInNode(label);
    });
  }

  function nestErrors(shadowRoot) {
    const form = shadowRoot.querySelector('form');
    if (!form) return;
    Array.from(form.children).forEach(function(child) {
      if (child.tagName === 'OUTPUT') {
        const prev = child.previousElementSibling;
        if (prev && prev.tagName !== 'OUTPUT' && prev.tagName !== 'SCRIPT') {
          prev.appendChild(child);
        }
      }
    });
  }

  // Map of form index -> which child positions (0-based, excluding OUTPUT/SCRIPT) should be half-width.
  // Positional indices are used because Shopify Forms renders fields inside a shadow DOM
  // without reliable name-based selectors we can target from outside.
  const halfWidthMap = {
    '0': [],
    '1': [3, 4, 5, 6],
    '2': [1, 2],
    '3': []
  };

  function applyGridLayout(shadowRoot, formIndex) {
    const form = shadowRoot.querySelector('form');
    if (!form) return;
    const indices = halfWidthMap[formIndex];
    if (!indices) return;
    const fieldChildren = Array.from(form.children).filter(function(child) {
      const tag = child.tagName;
      return tag !== 'OUTPUT' && tag !== 'SCRIPT';
    });
    indices.forEach(function(i) {
      if (fieldChildren[i]) {
        fieldChildren[i].classList.add('half-width');
      }
    });
  }

  function findAndInject() {
    const allPanels = section.querySelectorAll('.faq-form__panel');
    allPanels.forEach(function(panel) {
      const formIndex = panel.getAttribute('data-form-index');
      const embed = panel.querySelector('shopify-forms-embed');
      if (!embed || !embed.shadowRoot) return;

      injectStyles(embed.shadowRoot);
      nestErrors(embed.shadowRoot);
      applyGridLayout(embed.shadowRoot, formIndex);
      colorStars(embed.shadowRoot);
      linkifyPrivacy(embed.shadowRoot);

      // Fix inline top on labels and watch for future changes
      fixLabels(embed.shadowRoot);
      if (!embed.getAttribute('data-label-observer')) {
        const labelObserver = new MutationObserver(function() {
          fixLabels(embed.shadowRoot);
          nestErrors(embed.shadowRoot);
          applyGridLayout(embed.shadowRoot, formIndex);
          colorStars(embed.shadowRoot);
          linkifyPrivacy(embed.shadowRoot);
        });
        labelObserver.observe(embed.shadowRoot, { attributes: true, childList: true, subtree: true, attributeFilter: ['style'] });
        embed.setAttribute('data-label-observer', 'true');
        observers.push(labelObserver);
      }
    });
  }

  // Try immediately (shadow root may already exist via declarative shadow DOM)
  findAndInject();

  // Also observe for dynamically added embeds
  const observer = new MutationObserver(findAndInject);
  observer.observe(section, { childList: true, subtree: true });
  observers.push(observer);

  // Store observers on the section element for cleanup
  section._faqObservers = observers;
}

function destroyFaqForm(section) {
  if (section._faqObservers) {
    section._faqObservers.forEach(function(obs) { obs.disconnect(); });
    section._faqObservers = null;
  }
}

// Initialize all FAQ form sections on the page
document.querySelectorAll('.faq-form').forEach(initFaqForm);

// Theme editor support
document.addEventListener('shopify:section:load', function(e) {
  const section = e.target.querySelector('.faq-form');
  if (section) initFaqForm(section);
});

document.addEventListener('shopify:section:unload', function(e) {
  const section = e.target.querySelector('.faq-form');
  if (section) destroyFaqForm(section);
});
